import { useEffect, useState } from "react";
import { useEmpresa } from "app/contexts";
import { telefonoRegex } from "app/utils/regexps";
import { useNavigate, useParams } from "react-router-dom";
import { ConditionalButton } from "app/components/buttons";
import { Container } from "app/components/container";
import { Row } from "app/components/row";
import { Column } from "app/components/column";
import { Input } from "app/components/input";
import { Checkbox } from "app/components/checkbox";
import { DFlexResponsive } from "app/components/d-flex-responsive";
import { Button } from "app/components/button";
import { CardFooter } from "app/components/card-footer";
import { CardBody } from "app/components/card-body";
import { CardHeader } from "app/components/card-header";
import { RouteError } from "app/components/route-error";

import toast from "react-hot-toast";

const initialState = {
  telefono: {
    telefono_numero: "",
    telefono_principal: false,
  },
  error: null,
};

export function TelefonoForm() {
  const params = useParams();
  const navigate = useNavigate();

  const { addTelefono, getTelefono, updateTelefono } = useEmpresa();

  const [state, setState] = useState(initialState);

  useEffect(() => {
    try {
      if (!!params.index) {
        const telefono = getTelefono(parseInt(params.index));

        setState((state) => ({
          ...state,
          telefono,
        }));
      }
    } catch (error) {
      setState((state) => ({ ...state, error }));
    }
  }, [params.index, getTelefono]);

  function handleSubmit(e) {
    e.preventDefault();

    try {
      if (!!params.index) {
        const updated = updateTelefono(parseInt(params.index), state.telefono);

        if (!!updated) {
          toast.success("¡Número de teléfono actualizado!");

          return navigate("../../");
        }
      } else {
        const added = addTelefono(state.telefono);

        if (!!added) {
          toast.success("¡Número de teléfono agregado!");

          return navigate("../../");
        }
      }
    } catch (error) {
      return toast.error(error.message);
    }
  }

  if (!!state.error) {
    return <RouteError message={state.error.message} navigateTo="../../" />;
  }

  return (
    <div className="col-sm-12 col-xl-6 offset-xl-3">
      <form className="card" onSubmit={handleSubmit}>
        <CardHeader
          header={`${!!params.index ? "Editar" : "Agregar"} número de teléfono`}
        />

        <CardBody>
          <Container>
            <Row>
              <Column>
                <Input
                  placeholder="Número de teléfono"
                  value={state.telefono.telefono_numero}
                  onChange={(e) =>
                    setState((state) => ({
                      ...state,
                      telefono: {
                        ...state.telefono,
                        telefono_numero: e.target.value.trim(),
                      },
                    }))
                  }
                  title="e. ej. 2442-1234"
                  pattern={telefonoRegex.source}
                  autoFocus
                />
              </Column>

              <Column>
                <Checkbox
                  label="¿Es un número de teléfono principal?"
                  checked={state.telefono.telefono_principal}
                  onChange={(e) =>
                    setState((state) => ({
                      ...state,
                      telefono: {
                        ...state.telefono,
                        telefono_principal: e.target.checked,
                      },
                    }))
                  }
                />
              </Column>
            </Row>
          </Container>
        </CardBody>

        <CardFooter>
          <DFlexResponsive justifyContent="end">
            <ConditionalButton
              type="submit"
              condition={!params.index}
              titleWhenTrue="Agregar"
              titleWhenFalse="Actualizar"
            />

            <Button
              color="secondary"
              title="Cancelar"
              outline
              onClick={() => navigate("../../")}
            />
          </DFlexResponsive>
        </CardFooter>
      </form>
    </div>
  );
}
